
<!-- <div class="login_flex" *ngIf="!isLoading">
    <div class="iltt_colone">
        <div class="log_colone">
            <h1 class="log_head">CCTV Application</h1>
        </div>
        <div class="log_colone_topper">
            <figure class="mb-0">
                <img src="../../assets/image/cctvloginimg.png" alt="loginimg" class="loginimg">
            </figure>
        </div>
        <div class="aced_comp">
            <p class="log_acedstudents">© 2023, Sri Chaitanya Educational Institutions. All rights reserved.</p>
        </div>
    </div>
    <div class="iltt_coltwo">
        <div class="row">
            <div class="col-md-12">
                <div class="log_card">
                    <form class="form-horizontal" [formGroup]="loginform" >
                        <div class="row">
                            <div class="col-md-12">
                                <h4 class="mis_sign_achd"><span>
                                        <img src="../../assets/image/sclogo.png" alt="sclogo" class="sclogo"></span>
                                    Sign in to your account
                                </h4>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <h4 class="mis_sign_hd">Sign in with Password</h4>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <input type="email" class="form-control" id="inputEmail3"
                                        placeholder="Email or Username" formControlName="userid">
                                    <i class="fa fa-user"></i>
                                    <div *ngIf="(loginform.controls['userid'].touched||isFormInvalid)&&loginform.get('userid')?.hasError('required')"
                                    style="color: rgb(255, 0, 0);">* payroll Id must be required</div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group help">
                                    <input [type]="showpassword ? 'text':'password'" class="form-control" id="inputPassword3"
                                        placeholder="Password" formControlName="password">
                                    <i class="fa fa-lock"></i>
                                    <a class="eyeslash">
                                    <i (click)="toggleshow()"  class="fa-solid fa-eye" *ngIf="showpassword"></i>
                                    <i (click)="toggleshow()"  class="fa-solid fa-eye-slash" *ngIf="!showpassword"></i></a>
                                    <div *ngIf="(loginform.controls['password'].touched||isFormInvalid)&&loginform.get('password')?.hasError('required')"
                                    style="color: rgb(255, 0, 0);">* password must be required</div>
                                    <div *ngIf="loginError"><small class="text-danger" style="text-align: right; width: 85%;">*bad crendentials</small></div>
                                </div> 
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <div class="main-checkbox">
                                        <input type="checkbox" value="None" id="checkbox1" name="check"
                                            formControlName="accept">
                                        <label for="checkbox1"></label>
                                    </div>
                                    <span class="text">Remember me</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <button type="button" class="mis_loginbtn" (click)="token()">Login</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <span class="forgot"><a href="" style="text-decoration: none;">Forgot
                                        Password?</a></span>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div> -->

<!-- ================== loader ==================-->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>

